// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

// Query String
const queryString = require('querystring');

class NotificationAPI extends MainAPI {
    /**
    * @return {object} notification list
    * @param {*} notificationDetails - Contains pagination data
    */
    async getNotification(petId, notificationDetails) {
		let queryParams = notificationDetails ? `?${queryString.stringify(notificationDetails)}` : '';
		return API.get(`${ENDPOINTS.GET_NOTIFICATION}/${petId}${queryParams}`);
	}
	
	/**
    * @param {*} notificationScheduleId
    */
    async putNotification(notificationScheduleId) {
		return API.put(`${ENDPOINTS.PUT_NOTIFICATION}/${notificationScheduleId}`);
	}

  /**
   * Marks user all notifications as read.
   * @returns {Promise} A promise that resolves when the operation is complete.
   */
  async markAllAsReadNotifications() {
      return API.put(`${ENDPOINTS.PUT_ALL_NOTIFICATIONS}`);
  }
}

export default new NotificationAPI();